import { FormGroup, Input, Label } from "reactstrap";
import { useBjelinTranslations } from "../../../hooks/TranslationHooks";
import EmailValidator from "email-validator";
import FieldError from "./FieldError";
import FieldRequired from "./FieldRequired";

const EmailField = ({
  label = "email.address",
  email,
  callback,
  errors,
  field = "email",
  required = false,
  disabled = false,
  validate = true
}) => {
  const t = useBjelinTranslations();
  const valid = validate
    ? EmailValidator.validate(email)
      ? { valid: true }
      : { invalid: email !== "" }
    : {};
  return (
    <FormGroup>
      <Label>
        {t(label)}
        {required && <FieldRequired />}
        <Input
          className={"input-" + field}
          type={"email"}
          autoComplete={"email"}
          value={email}
          onChange={e => callback(e.target.value)}
          placeholder={t(label)}
          disabled={disabled}
          {...valid}
        />
      </Label>
      <FieldError errors={errors} field={field} />
    </FormGroup>
  );
};

export default EmailField;
